import styled from 'styled-components';
import {device} from '../../../styled/device';
import Input from 'components/acommon/FieldInput';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CardRow = styled.div`
  display: flex;
  margin: 26px 0 45px;
  gap: 20px;

  @media (max-width: ${device.mobileXL}) {
    flex-wrap: wrap;
    margin: 26px 0;
  }
`;

export const InputAge = styled(Input)`
  min-width: 88px;

  & .input_error-message {
    right: initial;
  }
`;

export const TaxesSelectWrapper = styled.div`
  width: 200%;

  @media (max-width: ${device.tablet}) {
    min-width: 88px;
  }
`;
